// import ApplicantEdit from "./assessmentEdit/ApplicantEdit";
// import { getapplicantAss, getAttachment } from '../../../shared/utils/storage';
import { FaAddressCard, FaEdit, FaFile, FaIdCard, FaPassport, FaUser } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { imageUrl, url } from '../../../shared/services/apiService';
import { getSearchInfo } from '../../../shared/utils/storage';
import { useEffect, useState } from "react";

const ApplicantInfo = () => {
  //const data = useLocation().state
  const [application, setApplication] = useState()

  useEffect(() => {
    const searchedData = getSearchInfo()
    if (searchedData) {
      setApplication(searchedData?.data)
    }
  }, [])
  const personalInfo = application?.PersonalInfo[0]
  const addressInfo = application?.AddressInfo[0]
  const applicationInfo = application?.ApplicationInfo[0]
  const photo = application?.AttachmentInfo[0]
  const imagePath = photo?.AttachmentPath
    ? `${url}get_file?path=${photo?.AttachmentPath}`
    : null;



  const styles = {
    h4: {
      color: '#850505',
      textTransform: 'uppercase',
    }
  };

  return (
    <>
      <table id="viewTable">
        <tbody>
        <tr>
          <th colSpan="4">
            <h4>
              <b>Applicant Information</b>
            </h4>
          </th>
          <th
            style={{
              textAlign: "right",
              border: "1px",
            }}
          >
            <b>
              <FaIdCard style={{ fontSize: "23px" }} />
            </b>
            {/* <ApplicantEdit /> */}
          </th>
        </tr>
        <tr>
          <td style={{ width: "20%" }}>
            Jina la Kwanza: <br />{" "}
            <h4 style={styles.h4}>{personalInfo?.FirstName}</h4>
          </td>
          <td style={{ width: "20%" }}>
            Jina la Kati: <br />{" "}
            <h4 style={styles.h4}>{personalInfo?.MiddleName}</h4>
          </td>
          <td style={{ width: "20%" }}>
            Jina la Ukoo: <br />{" "}
            <h4 style={styles.h4}>{personalInfo?.FamilyName}</h4>
          </td>
          <td style={{ width: "20%" }}>
            Jinsia: <br />{" "}
            <h4 style={styles.h4}>{personalInfo?.GenderName}</h4>
          </td>
          <td rowSpan="2" className="centerItems" >
            {/* <div className="col-sm-3"> */}
            {/* <div className="row"> */}
            {imagePath ? (
              <img src={imagePath} className="passportSize" alt="User uploaded photo" />
            ) : (
              <p>No image available</p>
            )}
            {/* </div> */}
            {/* </div> */}

            {/* <img src="http://localhost:5000/20241230140817.jpg" width="220px" height="250px" /> */}
          </td>
        </tr>
        {/* <tr>
          <td>
            Tarifa za Ndoa: <br />
            <h4 style={styles.h4}>
              {personalInfo?.MaritalstatusName}
            </h4>
          </td>
          <td>
            Kazi: <br />
            <h4 style={styles.h4}>{personalInfo?.Occupation}</h4>
          </td>
          <td>
            Kitambulisho cha Taifa: <br />
            <h4 style={styles.h4}>{personalInfo?.NationalID}</h4>
          </td>
          <td>
            Kitambulisho cha Zanzibar: <br />
            <h4 style={styles.h4}>{personalInfo?.ZanzibarID}</h4>
          </td>
        </tr> */}
        <tr>
          <td>
            Tarehe ya Kuzaliwa: <br />
            <h4 style={styles.h4}>{personalInfo?.ApplicantDoB}</h4>
          </td>
          <td>
            Nchi: <br />{" "}
            <h4 style={styles.h4}>
              {personalInfo?.CountryName}
            </h4>
          </td>
          <td>
            Eneo: <br />{" "}
            <h4 style={styles.h4}>
              {personalInfo?.TerritoryName}
            </h4>
          </td>
          <td>
            Mkoa: <br />{" "}
            <h4 style={styles.h4}>
              {personalInfo?.RegionName}
            </h4>
          </td>
        </tr>
        <tr>
          <td>
            Wilaya: <br />{" "}
            <h4 style={styles.h4}>{personalInfo?.DistrictName}</h4>
          </td>
          <td>
            Kata/Shehia: <br />
            <h4 style={styles.h4}>{personalInfo?.WardName}</h4>
          </td>
          <td colSpan={3}>
            Mtaa: <br />{" "}
            <h4 style={styles.h4}>{personalInfo?.BirthVillage}</h4>
          </td>
          {/* <td>
            Mawasiliano: <br />{" "}
            <h4 style={styles.h4}>{personalInfo?.PhoneNumber}</h4>
          </td> */}
        </tr>
        </tbody>
      </table>
      <table id="viewTable">
        <tbody>
        <tr>
          <th colSpan="3">
            <h4>
              <b>Application Informations</b>
            </h4>
          </th>
          <th
            style={{
              textAlign: "right",
              border: "1px",
            }}
          >
            <b>
              <FaFile style={{ fontSize: "23px" }} />
            </b>
            {/* <ParentsEdit /> */}
          </th>
        </tr>
        <tr>
          <td style={{ width: "25%" }}>
            Application ID : <br />{" "}
            <h4 style={styles.h4}>{applicationInfo?.ApplicationID}</h4>
          </td>
          <td style={{ width: "25%" }}>
            Document Number: <br />{" "}
            <h4 style={styles.h4}>{applicationInfo?.DocNumber}</h4>
          </td>
          <td>
            Application Type: <br />{" "}
            <h4 style={styles.h4}>
              {applicationInfo?.TypeName}
            </h4>
          </td>
          <td>
            Personal ID: <br />
            <h4 style={styles.h4}>{applicationInfo?.PersonID}</h4>
          </td>
        </tr>
        {/* <tr>
          <td>
            Application Type: <br />{" "}
            <h4 style={styles.h4}>
              {applicationInfo?.TypeName}
            </h4>
          </td>
          <td>
            Personal ID: <br />
            <h4 style={styles.h4}>{applicationInfo?.PersonID}</h4>
          </td>
       
        </tr> */}
        <tr>
          <td colSpan="4"></td>
        </tr>
        </tbody>
      </table>
      <table id="viewTable">
        <tbody>
        <tr>
          <th colSpan="3">
            <h4>
              <b>Address Informations</b>
            </h4>
          </th>
          <th
            style={{
              textAlign: "right",
              border: "1px",
            }}
          >
            <b>
              <FaAddressCard style={{ fontSize: "23px" }} />
            </b>
            {/* <ParentsEdit /> */}
          </th>
        </tr>
        <tr>
          <td>
            Nambari Ya Simu: <br />{" "}
            <h4 style={styles.h4}>{addressInfo?.PhoneNumber}</h4>
          </td>
          <td>
            Email: <br />{" "}
            <h4 style={styles.h4}>{addressInfo?.Email}</h4>
          </td>
          <td>
            Nchi: <br />{" "}
            <h4 style={styles.h4}>
              {addressInfo?.CountryName}
            </h4>
          </td>
          <td>
            Eneo: <br />{" "}
            <h4 style={styles.h4}>
              {addressInfo?.TerritoryName}
            </h4>
          </td>
        </tr>
        <tr>
          <td>
            Mkoa: <br />{" "}
            <h4 style={styles.h4}>
              {addressInfo?.RegionName}
            </h4>
          </td>
          <td>
            Wilaya: <br />
            <h4 style={styles.h4}>{addressInfo?.DistrictName}</h4>
          </td>

          <td>
            Kijiji/Mtaa: <br />
            <h4 style={styles.h4}>{addressInfo?.VillageName}</h4>
          </td>
          <td>
            Nambari ya Nyumba: <br />
            <h4 style={styles.h4}>{addressInfo?.HouseNumber}</h4>
          </td>
        </tr>
        <tr>
          <td colSpan="4"></td>
        </tr>
        </tbody>
      </table>
    </>
  );
}

export default ApplicantInfo;
